const isEmpty = (value) => value === '' || value === null || value === undefined

const toNumber = (value) => {
  const num = Number(value)
  return Number.isNaN(num) ? null : num
}

export const prescriptionMaxValue = (limit, displayLimit = limit) => (value) => {
  if (isEmpty(value)) return undefined

  const num = toNumber(value)
  if (num === null) return undefined

  return num > limit ? `Max: ${displayLimit}` : undefined
}

export const prescriptionMinValue = (limit, displayLimit = limit) => (value) => {
  if (isEmpty(value)) return undefined

  const num = toNumber(value)
  if (num === null) return undefined

  return num < limit ? `Min: ${displayLimit}` : undefined
}

export const PRESCRIPTION_FIELD_VALIDATIONS = {
  sphere: [prescriptionMaxValue(23.5, '23.50')],
  cylinder: [prescriptionMaxValue(11.5, '11.50')],
  axis: [prescriptionMaxValue(180, '180')],
  distance_pd: [prescriptionMinValue(40, '40.0')],
  near_pd: [prescriptionMinValue(40, '40.0')],
  addition: [prescriptionMaxValue(8, '8.00')],
  segment_height: [prescriptionMaxValue(35, '35.0')],
  optical_center: [prescriptionMaxValue(30, '30.0')],
  horizontal_prism: [prescriptionMaxValue(14, '14.00')],
  vertical_prism: [prescriptionMaxValue(30, '30.00')],
}

export const getPrescriptionFieldValidations = (suffix) => PRESCRIPTION_FIELD_VALIDATIONS[suffix]
